import { toast as sonnerToast } from "sonner";
import { Toast, type ToastStatus } from "./Toast";

interface ToastAction {
  label: string;
  onPress: () => void;
}

interface ShowToastOptions {
  action?: ToastAction;
  description: string;
  duration?: number;
  status?: ToastStatus;
  title: string;
}

type ConvenienceOptions = Omit<ShowToastOptions, "title" | "description" | "status">;

function showToast({ status = "success", title, description, action, duration }: ShowToastOptions) {
  return sonnerToast.custom(
    (id) => (
      <Toast status={status} title={title} description={description} onClose={() => sonnerToast.dismiss(id)}>
        {action && <Toast.Action label={action.label} onPress={action.onPress} />}
      </Toast>
    ),
    { duration },
  );
}

showToast.success = (title: string, description: string, opts?: ConvenienceOptions) =>
  showToast({ ...opts, title, description, status: "success" });

showToast.error = (title: string, description: string, opts?: ConvenienceOptions) =>
  showToast({ ...opts, title, description, status: "error" });

showToast.achievement = (title: string, description: string, opts?: ConvenienceOptions) =>
  showToast({ ...opts, title, description, status: "achievement" });

showToast.info = (title: string, description: string, opts?: ConvenienceOptions) =>
  showToast({ ...opts, title, description, status: "info" });

showToast.warning = (title: string, description: string, opts?: ConvenienceOptions) =>
  showToast({ ...opts, title, description, status: "warning" });

export { showToast };
